// const sucessColor = '#0F9D58';
// const warnColor ='#F4B400';
// const errorColor = '#DB4437';

const commonPasswords = [
    '123456',
    '123456789',
    'password',
    'admin',
    'qwerty',
    'letmein',
    'monkey',
    'welcome',
    'dragon',
    'baseball',
    'iloveyou',
    'sunshine',
    'master',
    '123123',
    'starwars',
    'football',
    'princess',
    'shadow',
    '654321',
    'superman',
    'batman',
    'trustno1'
];
// eslint-disable-next-line no-useless-escape
var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
// const mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})');

const isPasswordCommon = (password) => {
    return commonPasswords.includes(password.toLocaleLowerCase());
};
const isPasswordsEquals = (password1, password2) => {
    // * compare the two strings (case sensitive ) and return a boolean
    return  password1.localeCompare(password2, undefined, ) === 0; // * non case sensitive : password1.localeCompare(password2, undefined, { sensitivity: 'accent' }) === 0;
};

const isPasswordStrong = (password) => {
    // if (!strongRegex.test(password)) {
    //     setSignupError("password not valid, it must contains number, capitalized ands 8 chracters ")
    // }
    // https://codepen.io/zd87/pen/zYOqRYa codeopen code verification
    if (strongRegex.test(password)) {
        // setBgC(sucessColor);
        return true;
    }
    // else if (mediumRegex.test(password)) {
    //     setBgC(warnColor);
    // }
    else {
        return false;
        // setBgC(errorColor);
        // setSignupErrorPassword('mot de passe non valide, il doit contenir un chiffre en majuscule et 8 caractères');
    }
    // * OLD JSX
    // ||
    // 			backgroundColor == warnColor ?
    //     ('password moyenne 🤔') :
    //     backgroundColor == sucessColor ?
    //         ('password forte 😎') : ('pwd faible 😣')
};

export function isValidEmail(email) {
    var re = /\S+@\S+\.\S+/;
    if (re.test(email) == false) {
        return false;
    }
    else {
        return true;
    }
}

export const validatePassword = (password, repeatedPassword,setPasswordError, setIsPasswordValid ) => {
    console.log('isPasswordCommon',isPasswordCommon(password), '!isPasswordStrong', !isPasswordStrong(password), '!isPasswordsEquals', !isPasswordsEquals(password, repeatedPassword) );
    if(password !== ''){
        if(isPasswordCommon(password)){
            setPasswordError('PASSWORD_COMMON');
            setIsPasswordValid(false);
        }
        else if(!isPasswordStrong(password)){
            setPasswordError('PASSWORD_WEAK');
            setIsPasswordValid(false);
        }
        // * I hope the setter did the job in this stage (async)
        // else if(!isPasswordsEquals(password, repeatedPassword) && repeatedPassword!= ''){
        else if(!isPasswordsEquals(password, repeatedPassword)){
            setPasswordError('PASSWORDS_DIFF');
            setIsPasswordValid(false);
        }
        else if(repeatedPassword!= ''){
            setPasswordError(null);
            setIsPasswordValid(true);
        }
    }
    // * to start with a clean input without error
    // else {
    //     setPasswordError(null);
    //     setIsPasswordValid(true);
    // }
};
